import React from "react";
import { useEffect } from "react";
import DaftarPinjaman from "../../components/Pinjam/ListPinjam";

const DaftarPinjam = () => {
  useEffect(() => {
    document.title = "Si TASIK - Daftar Peminjaman";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="p-6">
      <DaftarPinjaman/>
    </div>
  );
};

export default DaftarPinjam;
